import apiManager from '../../api/api-manager';
import { DocumentContentProviderApiAxiosParamCreator } from '../../api/generated/papyrus-stream';
import { CommunicationsFilter, Document } from '../../model';
import { DownloadDocumentsError } from '../../store';
import { AsyncThunkConfig } from '../../store/async-thunk-config';
import { getAPIRequestHeaders, GetThunkAPI } from '../../utils/api-utils';
import { DocumentsRepository } from './documents-repository';
import { papyrusDocumentsRepository } from './papyrus/documents-repository-papyrus';

class TransitionDocumentsRepository implements DocumentsRepository {
  getContractsList = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>
  ) => papyrusDocumentsRepository.getContractsList(thunkApi);
  getDispositionsList = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>
  ) => papyrusDocumentsRepository.getDispositionsList(thunkApi);
  getExpiredDocumentsList = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>
  ) => papyrusDocumentsRepository.getExpiredDocumentsList(thunkApi);
  getUnreadDocumentsCount = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>
  ) => papyrusDocumentsRepository.getUnreadDocumentsCount(thunkApi);
  getOfferDocuments = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>
  ) => papyrusDocumentsRepository.getOfferDocuments(thunkApi);
  getCommunicationDocuments = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>,
    filter: CommunicationsFilter
  ) => papyrusDocumentsRepository.getCommunicationDocuments(thunkApi, filter);
  setDocumentAsRead = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>,
    document: Document
  ) => {
    return apiManager.documentApi
      .notificaLettura(
        {
          documentId: document.id,
        },
        getAPIRequestHeaders(thunkApi)
      )
      .then((response) => response.status === 200);
  };
  downloadDocument = (
    thunkApi: GetThunkAPI<AsyncThunkConfig<DownloadDocumentsError>>,
    documentId: string,
    token?: string,
    behalf?: boolean
  ) =>
    papyrusDocumentsRepository.downloadDocument(
      thunkApi,
      documentId,
      token,
      behalf
    );
  uploadDocument = DocumentContentProviderApiAxiosParamCreator;
  getAzimutLifeAccessToken = (token: string): Promise<string> => {
    return apiManager.azimutLifeApi
      .getAzimutLifePage({
        headers: { Authorization: `BEARER ${token}` },
      })
      .then((val) => val.data);
  };
}

const transitionDocumentsRepository = new TransitionDocumentsRepository();
export default transitionDocumentsRepository;
